"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListModel = exports.EIVListModel = exports.eivs = exports.EIV = exports.balanceAreas = exports.dsos = exports.tsos = exports.BalanceAreaListModel = exports.BalanceArea = exports.DSOListModel = exports.DSO = exports.BTRListModel = exports.btrs = exports.BTR = exports.TSOListModel = exports.TSO = exports.WLPartnerListModel = exports.WlPartner = exports.wlPartners = exports.BalanceGroupListModel = exports.BalanceGroup = exports.balanceGroups = exports.ListModelType = exports.listModelTypes = void 0;
var zod_1 = require("zod");
var util_1 = require("../util");
var TSO_DSO_BALANCE_AREA_json_1 = __importDefault(require("./TSO-DSO-BALANCE_AREA.json"));
exports.listModelTypes = ['BALANCE_AREA', 'BALANCE_GROUP', 'BTR', 'EIV', 'DSO', 'TSO', 'WL_PARTNER'];
exports.ListModelType = zod_1.z.enum(exports.listModelTypes);
exports.balanceGroups = [
    '11X0-0000-0039-7',
    '11Y0-0000-0416-R',
    '11Y0-0000-1810-J',
    '11Y0-0000-0017-7',
    '11Y0-0000-0669-P',
    '11Y0-0000-1276-7',
    '11X0-0000-0241-H',
    '11Y0-0000-1167-D',
];
exports.BalanceGroup = zod_1.z.enum(exports.balanceGroups);
exports.BalanceGroupListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.BALANCE_GROUP),
    data: zod_1.z.object({ value: zod_1.z.custom().and(zod_1.z.string()) }),
});
exports.wlPartners = ['ANE', 'BKW', 'DANSKE', 'E2M', 'NEAS', 'NORDGROON', 'OPTIMAX', 'SUNNIC', 'VSE'];
exports.WlPartner = zod_1.z.enum(exports.wlPartners);
exports.WLPartnerListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.WL_PARTNER),
    data: zod_1.z.object({ value: zod_1.z.custom().and(zod_1.z.string()) }),
});
exports.TSO = zod_1.z.object({
    bdewCode: zod_1.z.string(),
    controlZone: zod_1.z.string(),
    dsos: zod_1.z.array(zod_1.z.string()),
    value: zod_1.z.string(),
});
exports.TSOListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.TSO),
    data: exports.TSO,
});
exports.BTR = zod_1.z.object({ value: zod_1.z.string(), bdewCode: zod_1.z.string(), validFrom: util_1.zodDate });
exports.btrs = [
    {
        value: 'ANE GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9979581000006',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'BYTE MEE Softwareentwicklung GmbH (Marktrolle Betreiber)',
        bdewCode: '9979455000009',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'DanTysk Sandbank Offshore Wind GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9982769000003',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Deutsche Windtechnik Service GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9982331000001',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'E.ON Energie Deutschland GmbH (Marktrolle Betreiber)',
        bdewCode: '9979608000004',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'energy consult GmbH (Marktrolle Betreiber)',
        bdewCode: '9981706000000',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'montanWIND Windpark Gohlocher Wald GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9983068000009',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Nordgröön Energie GmbH (Marktrolle Betreiber)',
        bdewCode: '9979667000003',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Northland Deutsche Bucht GmbH (Marktrolle Betreiber)',
        bdewCode: '9982635000004',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Ocean Breeze Energy GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9982975000003',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Prowind Betriebsführungs- GmbH & Co. KG (Marktrolle Betreiber)',
        bdewCode: '9980557000003',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Steffen Stecher e.K. (Marktrolle Betreiber)',
        bdewCode: '9980399000005',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Vattenfall Energy Trading (Marktrolle Betreiber)',
        bdewCode: '9980054000001',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Veja Mate Offshore Project GmbH (Marktrolle Betreiber)',
        bdewCode: '9982654000001',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'VSE Aktiengesellschaft (Marktrolle Betreiber)',
        bdewCode: '9980400000001',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Wes Ibs Betriebsführungs- und Verwaltungs GmbH (Marktrolle Betreiber)',
        bdewCode: '9979827000009',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    { value: 'wpd windmanager technik GmbH', bdewCode: '9979806000004', validFrom: '2021-01-10T12:00:00.000Z' },
];
exports.BTRListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.BTR),
    data: exports.BTR,
});
exports.DSO = zod_1.z.object({
    bdewCode: zod_1.z.string(),
    tsoBalanceAreaPairs: zod_1.z
        .array(zod_1.z.object({
        tso: zod_1.z.string(),
        balanceArea: zod_1.z.string(),
    }))
        .optional()
        .nullable(),
    validFrom: util_1.zodDate,
    value: zod_1.z.string(),
});
exports.DSOListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.DSO),
    data: exports.DSO,
});
exports.BalanceArea = zod_1.z.object({
    description: zod_1.z.string(),
    dso: zod_1.z.object({ label: zod_1.z.string(), value: zod_1.z.string() }).optional().nullable(),
    value: zod_1.z.string(),
});
exports.BalanceAreaListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.BALANCE_AREA),
    data: exports.BalanceArea,
});
var unpackData = function (data) {
    var balanceAreas = {};
    var dsos = {};
    var tsos = {};
    data.forEach(function (element) {
        // Unpack TSOs from the data provided by the client
        if (!tsos[element.bdewCodeTSO]) {
            tsos[element.bdewCodeTSO] = {
                bdewCode: element.bdewCodeTSO,
                controlZone: element.controlZone,
                dsos: [element.bdewCodeDSO],
                value: element.tso,
            };
        }
        else {
            if (!tsos[element.bdewCodeTSO].dsos.includes(element.bdewCodeDSO)) {
                tsos[element.bdewCodeTSO].dsos = __spreadArray(__spreadArray([], tsos[element.bdewCodeTSO].dsos, true), [element.bdewCodeDSO], false);
            }
        }
        // Unpack DSOs from the data provided by the client
        if (!dsos[element.bdewCodeDSO]) {
            dsos[element.bdewCodeDSO] = {
                bdewCode: element.bdewCodeDSO,
                tsoBalanceAreaPairs: [{ balanceArea: element.balanceArea, tso: element.bdewCodeTSO }],
                validFrom: new Date(element.validFrom),
                value: element.dso,
            };
        }
        else {
            var tempPairs = dsos[element.bdewCodeDSO].tsoBalanceAreaPairs || [];
            dsos[element.bdewCodeDSO].tsoBalanceAreaPairs = __spreadArray(__spreadArray([], tempPairs, true), [
                { balanceArea: element.balanceArea, tso: element.bdewCodeTSO },
            ], false);
        }
        // Unpack balance areas from the data provided by the client
        if (!balanceAreas[element.balanceArea]) {
            balanceAreas[element.balanceArea] = {
                description: element.balanceAreaDescription,
                dso: { label: element.dso, value: element.bdewCodeDSO },
                value: element.balanceArea,
            };
        }
        else {
            if (!Object.keys(dsos).includes(element.bdewCodeDSO)) {
                balanceAreas[element.balanceArea].dso = { label: element.dso, value: element.bdewCodeDSO };
            }
        }
    });
    return {
        balanceAreas: Object.keys(balanceAreas).map(function (id) { return balanceAreas[id]; }),
        dsos: Object.keys(dsos).map(function (id) { return dsos[id]; }),
        tsos: Object.keys(tsos).map(function (id) { return tsos[id]; }),
    };
};
var dsoWithReferences = unpackData(TSO_DSO_BALANCE_AREA_json_1.default);
exports.tsos = dsoWithReferences.tsos;
exports.dsos = dsoWithReferences.dsos;
exports.balanceAreas = dsoWithReferences.balanceAreas;
exports.EIV = zod_1.z.object({ value: zod_1.z.string(), eivCode: zod_1.z.string(), validFrom: util_1.zodDate });
exports.eivs = [
    {
        value: 'E.ON Energie Deutschland GmbH (Marktrolle Einsatzverantwortlicher)',
        eivCode: '9978571000000',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Nordgröön Energie GmbH (Marktrolle Einsatzverantwortlicher)',
        eivCode: '9979440000006',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'Vattenfall Energy Trading (Marktrolle Einsatzverantwortlicher)',
        eivCode: '9978192000009',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
    {
        value: 'VSE Aktiengesellschaft (Marktrolle Einsatzverantwortlicher)',
        eivCode: '9911823000005',
        validFrom: '2021-01-10T12:00:00.000Z',
    },
];
exports.EIVListModel = zod_1.z.object({
    id: util_1.uuid.optional(),
    type: zod_1.z.literal(exports.ListModelType.Enum.EIV),
    data: exports.EIV,
});
exports.ListModel = zod_1.z.discriminatedUnion('type', [
    exports.BalanceAreaListModel,
    exports.BalanceGroupListModel,
    exports.BTRListModel,
    exports.DSOListModel,
    exports.EIVListModel,
    exports.TSOListModel,
    exports.WLPartnerListModel,
]);
